<template>
    <div
        class="rounded overflow-hidden"
    >
        <SectionTitle :title="$t('products.why_buy.title')"/>

        <ul class="list-unstyled mt-4">
            <li class="user-account-benefit">{{ $t('products.why_buy.line_1') }}</li>
            <li class="user-account-benefit">{{ $t('products.why_buy.line_2') }}</li>
            <li class="user-account-benefit" v-html="$t('products.why_buy.line_3')"/>
            <li
                class="user-account-benefit"
                v-html="$t('products.why_buy.line_4', {
                    customer_reviews: `<a target='__blank' href='https://uk.trustpilot.com/review/stonexbullion.com?utm_medium=trustbox&utm_source=Horizontal'><b>${$t('products.why_buy.customer_reviews')}</b></a>`
                })"
            ></li>
        </ul>
    </div>
</template>

<script setup lang="ts">
const SectionTitle = defineAsyncComponent(() => import('~/components/Product/SectionTitle.vue'))

</script>
